import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { PDFExport } from "@progress/kendo-react-pdf";

import RMSquat from '../../scchartcomponent/rmsquatchart';
import RMClean from '../../scchartcomponent/rmcleanchart';
import RMBench from '../../scchartcomponent/rmbenchchart';
import KMRun from'../../scchartcomponent/kmrunchart';
import VerticalJump from '../../scchartcomponent/verticaljumchart';
import PullUp from '../../scchartcomponent/pullupchart';
import Acceleration from '../../scchartcomponent/accelerationchart';
import Endurance from '../../scchartcomponent/endurancechart';

import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import PageTemplate from "Routes/pdfTemplate";

import {  
    scVisualisationDetails
} from 'Actions';

class mainvisual extends React.Component {
    static propTypes = {
        classes: PropTypes.object,
    };
    

    constructor(props) {
      
        super(props);
        this.state = {   
            
            selyear:this.props.data.selyear,
            selassessment:this.props.data.selassessment,
            visualid:this.props.data.visualid, 
            previousLength:0,
            valuelength:0,
        };
       this.selectorRef = React.createRef(null);
    }

    exportPDFWithMethod = () => {
        this.selectorRef.current.save();
    }   

    handleInput(event) {
        const bullet = "\u2022";
        const inputValue = event.target.value;
        const cursorPosition = event.target.selectionStart;
        let lines = inputValue.split('\n');
      
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          if (!line.trim().startsWith(bullet)) {
            lines[i] = `${bullet} ${line.trimLeft()}`;
          }
        }
      
        let newValue = lines.join('\n');
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          if (cursorPosition === 0) {
            const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
            if (lineIndex > 0) {
              const linesArray = newValue.split('\n');
              linesArray.splice(lineIndex, 1);
              newValue = linesArray.join('\n');
            }
          } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
            newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
          }
        }
      
        event.target.value = newValue;
      
        this.setState({
          previousLength: newValue.length,
        });
     }

  render() {

    const { scvisualisationdetails, loading} = this.props;
    let visualdetails=scvisualisationdetails[0].visualimpression;
    let summary_notes='';
    let clubhd_impression='';
    let clubhdshrtgoal1='';
    let clubhdlonggoal1='';
    let clubhd_approach='';
    if(visualdetails.length!=0){
        summary_notes= visualdetails[0].summary_notes; 
        clubhd_impression=visualdetails[0].clubhd_impression; 
        clubhdshrtgoal1=visualdetails[0].clubhdshrtgoal1; 
        clubhdlonggoal1=visualdetails[0].clubhdlonggoal1; 
        clubhd_approach=visualdetails[0].clubhd_approach; 
        
    }
    const styles = {
        mainheading: {
            fontWeight:"bold",
            marginBottom:"30px",
            color:"#000",
            marginTop:"30px"
        },
        subheading: {
            fontWeight:"bold",
            marginTop:"50px", 
            marginBottom:"30px",
            color:"#000",
            position:"relative"
        },
        subheadingsecond: {
            fontWeight:"bold",
            marginTop:"30px", 
            marginBottom:"20px",
            color:"#000",
            position:"relative"
        },
        subheadingfirst: {
            fontWeight:"bold",
            marginTop:"30px", 
            marginBottom:"30px",
            color:"#000",
            position:"relative"
        },
        goals:{
            marginTop:"30px",
            marginBottom:"20px",
            color:"#000"
        },
        goalhead:{
          fontWeight:"bold",
          color:"#000"
        },        
        eachchart:{
           padding:"10px",
           marginBottom:"50px",
           position:"relative"
        },
        texare:{
            color:"#000",
            backgroundColor:"unset"
        },
        table: {
            border: "1px solid black",
            borderColor:"black",
            borderStyle:"solid",
            fontFamily: "Arial",            
            zIndex:"100"
        },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word",            
            textAlign: "center",
            color:"#000"
        },
        tabletleft: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word"
            
        },
        tabletrtdhead: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word",            
            textAlign: "center",
            color:"#000",
            fontWeight:"bold"
        },
        rctcontent:{            
            marginTop:"30px",
            borderRadius: "5px",
            boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
            border: "none",
            transition: "all 0.4s ease-in-out 0s",
            marginBottom: "24px",
            padding:"0px 20px 10px 20px",
            zIndex:"1"
        }
    };


    const studentName = this.props.data.studentName || '';
    const pdfFileName = `${studentName} - S&C Comparative Analysis Report`;
    const details = scvisualisationdetails[0];
    const chartGroups = [
        [
            details.onermsquat.length!=0 && { key: 'squat', title: '1RM Back Squat', headingStyle: styles.subheadingfirst, chart: <RMSquat data={'95%'}/> },
            details.onermclean.length!=0 && { key: 'clean', title: '1RM Clean', headingStyle: styles.subheadingfirst, chart: <RMClean data={'95%'}/> },
        ].filter(Boolean),
        [
            details.onermbench.length!=0 && { key: 'bench', title: '1RM Bench Press', headingStyle: styles.subheading, chart: <RMBench data={'95%'}/> },
            details.kmrun.length!=0 && { key: 'kmrun', title: 'Aerobic Fitness Test (2.4km Run)', headingStyle: styles.subheadingsecond, chart: <KMRun data={'95%'}/> },
        ].filter(Boolean),
        [
            details.verticaljump.length!=0 && { key: 'vjump', title: 'Lower Body Power Test (Vertical Jump)', headingStyle: styles.subheading, chart: <VerticalJump data={'95%'}/> },
            details.pullup.length!=0 && { key: 'pullup', title: 'Upper Body Strength Test (Pull Up)', headingStyle: styles.subheadingsecond, chart: <PullUp data={'95%'}/> },
        ].filter(Boolean),
        [
            details.acceleration.length!=0 && { key: 'accel', title: 'Acceleration Speed Test (20m Sprint Speed)', headingStyle: styles.subheading, chart: <Acceleration data={'95%'}/> },
            details.endurance.length!=0 && { key: 'endurance', title: 'Core Endurance Test (Plank)', headingStyle: styles.subheadingsecond, chart: <Endurance data={'95%'}/> },
        ].filter(Boolean),
    ].filter(group => group.length > 0);

    return (
        <>
        <div className="rwhead">                    
            <button type="button" className="mr-10 mb-10 btn btn-outline-success" onClick={this.exportPDFWithMethod}>Export PDF</button>
            <input type="button" className="mr-10 mb-10 btn btn-outline-warning float-right" onClick={this.props.onClick} value="Back" />
        </div>
        <PDFExport
            pageTemplate={PageTemplate}
            scale={0.6}
            paperSize="A4"
            margin={{ top: "2.2cm", left: "1cm", right: "1cm", bottom: "1cm" }}
            fileName={pdfFileName}
            ref={this.selectorRef}
            forcePageBreak=".page-break"
        >
            <RctCollapsibleCard fullBlock > 
                <div style={styles.rctcontent}>                    
                    <div className="rwhead" style={{marginTop:"20px"}}>
                        <h3 className="text-center" style={styles.mainheading}>COMPARATIVE ANALYSIS OF STRENGTH & CONDITIONINGS</h3>
                    </div>
                    {chartGroups.map((group, groupIndex) => (
                        <React.Fragment key={`group-${groupIndex}`}>
                            {groupIndex > 0 ? <div className="page-break"></div> : null}
                            {group.map((item) => (
                                <div key={item.key}>
                                    <h3 className="text-center" style={item.headingStyle}>{item.title}</h3>
                                    <div style={styles.eachchart}>
                                        {item.chart}
                                    </div>
                                </div>
                            ))}
                        </React.Fragment>
                    ))}
                    {chartGroups.length > 0 ? <div className="page-break"></div> : null}
                    <h3 className="text-center" style={styles.subheading}>SUMMARY NOTES </h3>
                    <div style={styles.eachchart}>
                        <div className="row rwhead">
                            <textarea rows="4" type="text" style={styles.texare} name="summary_notes" id="summary_notes" defaultValue={summary_notes} className="form-control" disabled></textarea>
                        </div>
                    </div>
             
                    <h3 className="text-center" style={styles.subheading}>PERFORMANCE ENHANCEMENT</h3>
                    <div style={styles.eachchart}>
                            <table className="table align-items-center table-flush" style={styles.table}>
                                    <tbody>
                                        <tr>                                          
                                            <td rowSpan="2" style={styles.tabletrtdhead}>IMPRESSION  </td>
                                            <td colSpan="2" style={styles.tabletrtdhead}>GOAL  </td>
                                            <td rowSpan="2"style={styles.tabletrtdhead}>APPROACH </td>
                                        </tr>
                                        <tr>
                                            <td style={styles.tabletrtdhead}>Short Term Goals</td>
                                            <td style={styles.tabletrtdhead}>Long Term Goals</td>
                                        </tr> 
                                        <tr>  
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhd_impression} name="clubhd_impression" id="clubhd_impression" disabled></textarea></td>
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhdshrtgoal1} name="clubhdshrtgoal1" id="clubhdshrtgoal1" disabled></textarea></td>
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhdlonggoal1} name="clubhdlonggoal1" id="clubhdlonggoal1"  disabled></textarea></td>
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhd_approach} name="clubhd_approach" id="clubhd_approach" disabled></textarea></td>                                                   
                                        </tr>                           
                                    </tbody>
                                </table>   
                    </div>
                   
                </div>                
            </RctCollapsibleCard>   
        </PDFExport>
            <div className="rwhead">                    
                <input type="button" className="mr-10 mb-10 btn btn-outline-warning" onClick={this.props.onClick} value="Back" />
            </div>
      </>
    );
  }
}

const mapStateToProps = ({ scvisualisation }) => {
  const { scvisualisationdetails, loading } = scvisualisation;
return { scvisualisationdetails, loading };
}

export default connect(mapStateToProps, {
    scVisualisationDetails
})(mainvisual); 